import React from "react";
import Heading from "../components/Heading";
import CuInput from "../../all-patient/components/CuInput";
import CuDropdown from "../../common_component/component/CuDropdown";
import { useNavigate } from "react-router-dom";

const HelpCenterForm = () => {
  const navigate = useNavigate();
  return (
    <div className="p-4 px-6 h-screen">
      <Heading />

      <div className="max-w-[1220px] p-8 border rounded mt-6 m-auto">
        <div className="text-2xl font-bold">Contact Cufront Support</div>
        <div className="text-2xl text-[#777777]">
          What do you want to report?
        </div>
        <div className="my-10 text-[#000000]">
          If you have any question, please contact below
          <br />
          <span className="font-bold">rishabh607@gmail.com</span>
        </div>
        <div className="max-w-[502px] flex flex-col gap-4">
          <div className="w-full">
            <CuInput label={`Name`} placeholder={`Enter Name`} />
          </div>
          <div className="flex gap-2 w-full">
            <div className="w-full">
              <CuInput
                label={"Mobile Number"}
                type="number"
                placeholder={`Enter Mobile`}
              />
            </div>
            <div className="w-full">
              <CuInput
                label={`Email`}
                type="email"
                placeholder={`Enter Email`}
              />
            </div>
          </div>
          <div>
            <label>Contact Reason</label>
            <CuDropdown />
          </div>
          <div className="w-full">
            <label>Description </label>
            <textarea className="w-full border h-28"></textarea>
          </div>
          <div className="w-full">
            <label>Attach File</label>
            <div className="w-full flex gap-2">
              <div className="flex-1 h-11 rounded border"></div>
              <button className="border border-[#E2E1E5] bg-[#E1E1E1] rounded-[5px] w-[127px]">
                Browse
              </button>
            </div>
          </div>
          <div className="mt-6">
            <button
              className="bg-[#EBF8EC] border w-[239px] h-11"
              onClick={() => navigate("/new/settings/help-center/ticket")}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterForm;
